function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Fragment, useEffect, useState } from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { useRefCallback } from '@bydesign-ui/hooks';
import { format } from '@bydesign-ui/utils';
import { Checkbox } from '../checkbox';
import { Select } from '../select';
import { InputNumber } from '../input-number';
export function DynamicDateCustomize(props) {
  var _a, _b, _c;

  var disabled = props.disabled,
      disabledCheckMark = props.disabledCheckMark,
      initialValue = props.initialValue,
      _props$onlyShowStart = props.onlyShowStart,
      onlyShowStart = _props$onlyShowStart === void 0 ? false : _props$onlyShowStart,
      onChange = props.onChange,
      onDisabledChange = props.onDisabledChange;

  var _useLocale = useLocale('dynamic-date'),
      before = _useLocale.before,
      intervals = _objectWithoutProperties(_useLocale, ["before"]);

  var customizeLocale = useLocale('dynamic-date.customize');
  var intervalLocale = useLocale('dynamic-date.interval');
  var customizeCls = usePrefixCls('dynamic-date-customize');
  var customizeItemCls = usePrefixCls('dynamic-date-customize-item');

  var _useState = useState((_a = initialValue === null || initialValue === void 0 ? void 0 : initialValue.interval) !== null && _a !== void 0 ? _a : 'day'),
      _useState2 = _slicedToArray(_useState, 2),
      interval = _useState2[0],
      setInterval = _useState2[1];

  var _useState3 = useState((_b = initialValue === null || initialValue === void 0 ? void 0 : initialValue.offsets[0]) !== null && _b !== void 0 ? _b : 0),
      _useState4 = _slicedToArray(_useState3, 2),
      start = _useState4[0],
      setStart = _useState4[1];

  var _useState5 = useState((_c = initialValue === null || initialValue === void 0 ? void 0 : initialValue.offsets[1]) !== null && _c !== void 0 ? _c : 0),
      _useState6 = _slicedToArray(_useState5, 2),
      end = _useState6[0],
      setEnd = _useState6[1];

  var onDisabledChangeCallback = useRefCallback(onDisabledChange);
  var onChangeCallback = useRefCallback(onChange);
  useEffect(function () {
    if (!disabled) {
      onChangeCallback({
        type: 'dynamic',
        interval: interval,
        offsets: [start, end]
      });
    }
  }, [disabled, interval, start, end]);
  var intervalLocal = intervals[interval];
  var beforeStr = format(before, {
    value: '',
    unit: intervalLocal
  });
  return React.createElement("div", {
    className: customizeCls
  }, React.createElement(Checkbox, {
    className: customizeItemCls,
    checked: !disabled,
    disabled: disabledCheckMark,
    onValueChange: onDisabledChangeCallback
  }, customizeLocale), React.createElement("label", {
    className: customizeItemCls
  }, intervalLocale, React.createElement(Select, {
    size: "sm",
    value: interval,
    onChange: function onChange(val) {
      return setInterval(val !== null && val !== void 0 ? val : 'day');
    },
    clearable: false,
    disabled: disabled
  }, Object.entries(intervals).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        int = _ref2[0],
        label = _ref2[1];

    return React.createElement(Select.Option, {
      key: int,
      value: int,
      label: label
    });
  }))), React.createElement("span", {
    className: customizeItemCls
  }, React.createElement(InputNumber, {
    size: "sm",
    value: start,
    onChange: setStart,
    disabled: disabled
  }), beforeStr, !onlyShowStart && React.createElement(Fragment, null, ' ~ ', React.createElement(InputNumber, {
    size: "sm",
    value: end,
    onChange: setEnd,
    disabled: disabled
  }), beforeStr)));
}